
<ng-container *ngIf="viewType == 'imageList'">
  <div class="liner">
    <div class="ttl_form">{{headerText}}</div>
    <div class="list_photo_add clrfx">
      <div *ngFor="let file of fileList; let i = index"
           [attr.data-index]="i">

        <div class="item ins"
             title="{{ file.fileName }}"
             [style.background-image]="fileAsDataUrl(file)">
          <a class="delete" (click)="deleteButtonClick($event, file, i)">
            {{ deleteButtonText }}
          </a>
        </div>

      </div>

      <div *ngIf="!maxFileCount || maxFileCount < 1 || fileList.length < maxFileCount"
           class="item add">
        <input type="file"
               class="upload"
               [accept]="allowFileExtensions"
               (change)="addButtonClick($event)" />
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewType == 'fileNameList'">
  <div class="liner">
    <div class="ttl_form">{{ headerText }}</div>

    <div class="list_document">
      <div *ngFor="let file of fileList; let i = index"
           class="document delete"
           [attr.data-index]="i">
        <div class="in">
          {{ file.fileName }}
          <span>&nbsp;</span>
        </div>
        <a class="delete" (click)="deleteButtonClick($event, file, i)"></a>
      </div>
    </div>

    <div *ngIf="!maxFileCount || fileList.length < maxFileCount"
         class="item add add_file mini_add">
      <input type="file"
             class="upload"
             [accept]="allowFileExtensions"
             (change)="addButtonClick($event)"/>
      {{ addButtonText }}
    </div>
  </div>
</ng-container>
